import { LocatableEntity } from "@ots-frontend/ots-data";
import { EntityArrayMarkerProps, EntityMarker, EntityMarkerProps } from "../EntityMarker/EntityMarker";
import {getClusterMarkerOpts, MarkerClusterer} from "../MarkerClusterer/MarkerClusterer";
import { MarkerClustererProps} from "@react-google-maps/api";
import { Clusterer } from "@react-google-maps/marker-clusterer"

export type EntityMarkerClusterProps<T extends LocatableEntity> =
  Omit<MarkerClustererProps, "clusterer" | "children">
  & Omit<
  EntityArrayMarkerProps<T>,
  "clusterer"
>;

export const EntityMarkerClusterer = <T extends LocatableEntity, >(props: EntityMarkerClusterProps<T>) => {
  const {
    entities,
    icon,
    onHover,
    onHoverOut,
    onMarkerClick,
    ...rest
  } = props;

  return (
    <MarkerClusterer {...rest}>
      {(clusterer) =>
        <>
          {
            entities.map((e, index) => {
              // TODO: review for memo
              const opts = getClusterMarkerOpts(e.id, index, entities.length, clusterer);

              return (
                <MarkerInCluster
                  key={opts.key}
                  noClustererRedraw={opts.noClustererRedraw}
                  entity={e}
                  icon={icon}
                  onHover={onHover}
                  onHoverOut={onHoverOut}
                  onMarkerClick={onMarkerClick}
                  clusterer={clusterer}
                  index={index}
                  totalCount={entities.length} />
              );
            })
          }
        </>
      }
    </MarkerClusterer>
  );
};

type MarkerInClusterProps<T extends LocatableEntity> =
  Omit<EntityMarkerProps<T>, "position" | "clusterer">
  & {
  clusterer?: Clusterer,
  index: number
  totalCount: number
}

const MarkerInCluster = <T extends LocatableEntity, >(props: MarkerInClusterProps<T>) => {
  const {
    clusterer,
    index,
    totalCount,
    entity,
    ...rest
  } = props;

  return (
    <EntityMarker
      {...rest}
      position={{
        lat: entity.latLng!.latCoord,
        lng: entity.latLng!.longCoord
      }}
      clusterer={clusterer}
      entity={entity}
    />
  );
};
